import script from "./budgets-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./budgets-modal.vue?vue&type=script&setup=true&lang=js"

import "./budgets-modal.vue?vue&type=style&index=0&id=3ca3b950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca3b950"]])

export default __exports__